import { trpc } from "@/lib/trpc";
import { useAuth } from "@/_core/hooks/useAuth";

/**
 * Wrapper component that adds a red notification dot to the Settings icon
 * when auto-sync is disabled and there are unsynced changes.
 */
export function SyncNotificationBadge({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  // Only query when user is authenticated
  const autoSyncQuery = trpc.calendar.getAutoSync.useQuery(undefined, {
    enabled: !!user,
    retry: 1,
    staleTime: 60000, // Cache for 1 minute
  });
  const syncStatusQuery = trpc.calendar.syncStatus.useQuery(undefined, {
    enabled: !!user,
    retry: 1,
    staleTime: 30000, // Cache for 30 seconds
  });

  // Default to true (auto-sync enabled) if query fails or hasn't loaded yet
  const autoSyncEnabled = autoSyncQuery.data?.autoSync ?? true;
  const pending = syncStatusQuery.data?.pendingChangeCount ?? 0;
  const showDot = !autoSyncEnabled && pending > 0;

  return (
    <div className="relative inline-flex">
      {children}
      {showDot && (
        <div className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full" />
      )}
    </div>
  );
}
